import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ArticleGrid from './components/ArticleGrid';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://allchinabuyspreadsheet.fit';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <CategoryGrid />
        <ComparisonSection />
        <CTASection />
        <ArticleGrid />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'WebSite',
                name: 'AllChinaBuy Spreadsheet',
                url: `${SITE_URL}/`,
                description: 'Best AllChinaBuy Spreadsheet with verified sellers, updated product links, buying guides, and safety information.',
                potentialAction: {
                  '@type': 'SearchAction',
                  target: {
                    '@type': 'EntryPoint',
                    urlTemplate: `${SITE_URL}/allchinabuy-spreadsheet-guide`,
                  },
                },
              },
              {
                '@type': 'WebPage',
                '@id': `${SITE_URL}/#webpage`,
                url: `${SITE_URL}/`,
                name: 'Best AllChinaBuy Spreadsheet 2026 | Verified Sellers & Product Links',
                description: 'Explore the best AllChinaBuy Spreadsheet with trusted sellers, updated product links, buying guides, shipping tips, and safety information.',
                isPartOf: { '@id': `${SITE_URL}/#website` },
                about: { '@id': `${SITE_URL}/#organization` },
                breadcrumb: {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: `${SITE_URL}/`,
                    },
                  ],
                },
                mainEntity: { '@id': `${SITE_URL}/#faq` },
              },
              {
                '@type': 'Organization',
                '@id': `${SITE_URL}/#organization`,
                name: 'AllChinaBuy Spreadsheet',
                url: `${SITE_URL}/`,
              },
            ],
          }),
        }}
      />
    </>
  );
}